import { render, staticRenderFns } from "./ingreso_facturas.vue?vue&type=template&id=134dfee2&scoped=true"
import script from "./ingreso_facturas.js?vue&type=script&lang=js&external"
export * from "./ingreso_facturas.js?vue&type=script&lang=js&external"
import style0 from "./ingreso_facturas.scss?vue&type=style&index=0&id=134dfee2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134dfee2",
  null
  
)

export default component.exports